import React, { useState, useEffect } from 'react';

function GalleryFilters({ filters, onFilterChange, user }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    artists: [],
    sites: [],
    tags: [],
    colors: []
  });

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const response = await fetch('/api/images/filters', {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setFilterOptions(data);
      }
    } catch (err) {
      console.error('Failed to fetch filter options:', err);
    }
  };

  const handleChange = (key, value) => {
    onFilterChange({ [key]: value });
  };

  const clearFilters = () => {
    onFilterChange({
      artist: '',
      source_site: '',
      tag: '',
      color: '',
      rating: '',
      search: ''
    });
  };

  const activeFiltersCount = [
    filters.artist,
    filters.source_site,
    filters.tag,
    filters.color,
    filters.rating,
    filters.search
  ].filter(Boolean).length;

  return (
    <>
      <button 
        className="mobile-filter-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? '✕ Close' : '☰ Filters'}
        {activeFiltersCount > 0 && <span className="badge">{activeFiltersCount}</span>}
      </button>

      <aside className={`gallery-filters ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="filter-header">
          <h3>Filters</h3>
          {activeFiltersCount > 0 && (
            <button className="clear-filters" onClick={clearFilters}>
              Clear ({activeFiltersCount})
            </button>
          )}
        </div>

        <div className="filter-group">
          <label>Search</label>
          <input
            type="text"
            placeholder="Search images..."
            value={filters.search}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>NSFW Content</label>
          <select 
            value={filters.nsfw}
            onChange={(e) => handleChange('nsfw', e.target.value)}
          >
            <option value="blur">Blur explicit</option>
            <option value="hide">Hide explicit</option>
            <option value="show">Show explicit</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Artist</label>
          <select 
            value={filters.artist}
            onChange={(e) => handleChange('artist', e.target.value)}
          >
            <option value="">All artists</option>
            {filterOptions.artists.map(artist => (
              <option key={artist} value={artist}>{artist}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Source Site</label>
          <select 
            value={filters.source_site}
            onChange={(e) => handleChange('source_site', e.target.value)}
          >
            <option value="">All sites</option>
            {filterOptions.sites.map(site => (
              <option key={site} value={site}>{site}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Tag</label>
          <select 
            value={filters.tag}
            onChange={(e) => handleChange('tag', e.target.value)}
          >
            <option value="">All tags</option>
            {filterOptions.tags.map(tag => (
              <option key={tag} value={tag}>{tag}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Color</label>
          <div className="color-filter-grid">
            <button
              className={`color-btn ${filters.color === '' ? 'active' : ''}`}
              onClick={() => handleChange('color', '')}
            >
              All
            </button>
            {filterOptions.colors.map(color => (
              <button
                key={color}
                className={`color-btn ${filters.color === color ? 'active' : ''}`}
                style={{ backgroundColor: color }}
                onClick={() => handleChange('color', color)}
                title={color}
              />
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label>Rating</label>
          <select 
            value={filters.rating}
            onChange={(e) => handleChange('rating', e.target.value)}
          >
            <option value="">All ratings</option>
            <option value="safe">Safe</option>
            <option value="questionable">Questionable</option>
            <option value="explicit">Explicit</option>
          </select>
        </div>
      </aside>
    </>
  );
}

export default GalleryFilters;